import React, { useState, useEffect } from "react";
import style from "./AddInventoryPhotos.module.css";

function AddInventoryPhotos(props) {
  const [inputList, setInputList] = useState([]);
  const [inputImage, setInputImage] = useState("");
  const [max_upload, setMaxUpload] = useState("");
  const [imageErr, setImageError] = useState("");

  useEffect(
    () => {
      if (
        props.propsState.editImages &&
        props.propsState.editImages.length != 0
      ) {
        const list = props.propsState.editImages.map((item) => ({
          attachment_id: item.attachment_id,
          isNewUpload: false,
          delete: false,
          selectedFile: "",
          preview: item.attachment_url,
        }));
        setInputList(list);
      }

      let max_upload =
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO"))
          .max_product_image_upload;

      setMaxUpload(max_upload);
    },
    [props.propsState.editImages],
    max_upload
  );

  // handle input change
  const handleInputChange = (event, index) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      let FileSize = files && files[0].size / 1024 / 1024; // in MB
      if (/\.(jpe?g|png|svg)$/i.test(files && files[0].name) === false) {
        setImageError("Not an image");
      } else {
        if (FileSize > 2.0) {
          setImageError("Please upload file less than 2MB!");
        } else {
          setImageError("");
          let reader = new FileReader();
          reader.onload = (e) => {
            setInputImage({ inputImage: e.target.result });
            const list = [...inputList];
            list.push({
              selectedFile: files[0],
              preview: e.target.result,
              isNewUpload: true,
              attachment_id: "",
              delete: false,
            });
            setInputList(list);
            props.getPicData(list);
          };
          reader.readAsDataURL(event.target.files[0]);
        }
      }
    }
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    if (list[index].isNewUpload) {
      list.splice(index, 1);
    } else {
      list[index].delete = true;
    }
    setInputList(list);
    // const newListArr = list.filter((ele, index) => {
    //   return ele.selectedFile !== "";
    // });
    props.getPicData(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { selectedFile: "" }]);
  };

  // upload only image validation

  return (
    <div>
      {inputList && inputList.length < max_upload && (
        <div className="row">
          <div className="col">
            <div className="form-group">
              <div className={style.uploadBtnWrapper}>
                <button type="button" className={style.uploadBtn}>
                  <i className="fa fa-upload mr-2" aria-hidden="true"></i>{" "}
                  Upload
                </button>
                <input
                  type="file"
                  name="selectedFile"
                  multiple={true}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  title=""
                />
              </div>
              <span className="error ml-3">{imageErr ? imageErr : ""}</span>
            </div>
          </div>
        </div>
      )}

      <div className={style.imageContainer}>
        {inputList.map((x, i) => {
          return (
            <div className={`demo ${style.box}`}>
              <div className="row">
                <div className="col-lg-12">
                  {inputList.length > 0 && !x.delete && (
                    <div className={style.imageWidth}>
                      <div className={`form-group ${style.uploadedText}`}>
                        <div className={style.imageWrapper}>
                          <img height={"100%"} width={"100%"} src={x.preview} />
                        </div>
                        <i
                          className={`fa fa-times ${style.deleteIcon}`}
                          aria-hidden="true"
                          onClick={() => handleRemoveClick(i)}
                        ></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
    </div>
  );
}

export default AddInventoryPhotos;
